let handlers = {
    getAccessToken: () => null,
    refreshTokens: () => Promise.reject(new Error('Refresh handler not registered')),
    onUnauthorized: () => {},
};

let refreshPromise = null;

export const registerSessionHandlers = ({ getAccessToken, refreshTokens, onUnauthorized }) => {
    handlers = {
        getAccessToken: getAccessToken ?? handlers.getAccessToken,
        refreshTokens: refreshTokens ?? handlers.refreshTokens,
        onUnauthorized: onUnauthorized ?? handlers.onUnauthorized,
    };
};

export const clearSessionHandlers = () => {
    handlers = {
        getAccessToken: () => null,
        refreshTokens: () => Promise.reject(new Error('Refresh handler not registered')),
        onUnauthorized: () => {},
    };
    refreshPromise = null;
};

export const getAccessToken = () => handlers.getAccessToken?.() ?? null;

export const attemptTokenRefresh = () => {
    if (!handlers.refreshTokens) {
        return Promise.reject(new Error('Refresh handler not registered'));
    }
    if (!refreshPromise) {
        refreshPromise = Promise.resolve()
            .then(() => handlers.refreshTokens())
            .finally(() => {
                refreshPromise = null;
            });
    }
    return refreshPromise;
};

export const notifyUnauthorized = () => {
    if (handlers.onUnauthorized) {
        handlers.onUnauthorized();
    }
};
